const News = [
      {
            "news":" FACTS-H Lab is co-hosting CHORDS 2026",
            "link":"https://chords.iiitkottayam.ac.in",
            "description":"Bridging the gap between rigid computation and human societal dynamics, the FACTS-H Lab proudly joins forces with the Department of Computational Mathematics and Humanities to co-host CHORDS 2026."
       },
      

      {
            "news":" FACTS-H Lab Summer Internship Programme 2026,click here to apply",
            "link":"https://forms.gle/EybnTZ5VoMzZaY2R9",
            "description":"We are excited to announce that the Summer Internship Programme 2026, offered in a hybrid format. We invite motivated and talented students from institutions across India to apply. This internship is thoughtfully designed to equip students with valuable knowledge and hands-on experience in their area of interest within a focused timeframe."
       },

      {
            "news":" FACTS-H Lab Summer Internship Programme 2026 payment link",
            "link":"https://onlinesbi.sbi.bank.in/sbicollect/",
            "description":"payment link for summer internship 2026"
       },

      {
            "news":"Congratulations!!! Best paper AwardBest Paper Award  AI Explain: AI-Generated Graphic Storytelling for Explaining AI Across Cultures By Petra Ahrweiler, Gayathri Geetha Rajan(---Link---)",
            "link":"https://drive.google.com/file/d/12903REQc9jOBDGgpTpkownMKlCDou_f0/view?usp=sharing",
            "description":"-"
       },
     
      
  ];
  export default News


  